import { lazy } from "react";

// Lazy — fabric.js (o editor) só entra no bundle quando o atendente abre o
// editor de marcação (imagem anexada), nunca no carregamento inicial.
export const ImageMarkupEditor = lazy(() => import("./ImageMarkupEditor"));
export type { ImageMarkupEditorProps, EditorTool } from "./ImageMarkupEditor";

/**
 * Vale a pena abrir o editor de marcação para este arquivo?
 *
 * SVG fica de fora: o editor desenha num canvas e exporta raster, então um
 * vetor voltaria borrado e MAIOR que o original. Quem precisa marcar um SVG
 * exporta como PNG antes.
 *
 * ⚠️ Esta é a definição ÚNICA. Havia três cópias (uma no `MessageComposer` e
 * duas soltas no `SessionChat`); uma quarta no cartão de anexo teria posto um
 * botão "Editar" sobre um vetor.
 */
export function ehImagemEditavel(f: File): boolean {
  return f.type.startsWith("image/") && f.type !== "image/svg+xml";
}
